var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpiritual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#ec7b47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-255 347 100 100",
    style: {
      enableBackground: "new -255 347 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-205,367c16.6,0,30,13.4,30,30s-13.4,30-30,30s-30-13.4-30-30S-221.6,367-205,367 M-205,362   c-19.3,0-35,15.7-35,35s15.7,35,35,35s35-15.7,35-35S-185.7,362-205,362L-205,362z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -193,
    cy: 391,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -217,
    cy: 391,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-192.2,414.3c-0.1,0-0.3,0-0.4,0l-25.6-4.3c-1.4-0.2-2.3-1.5-2-2.9c0.2-1.4,1.5-2.3,2.9-2l25.6,4.3c1.4,0.2,2.3,1.5,2,2.9   C-189.9,413.5-191,414.3-192.2,414.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiritual);
export default __webpack_public_path__ + "static/media/spiritual.79416e7a97cd5b63b083b1bd4a0098a9.svg";
export { ForwardRef as ReactComponent };